import { gql, useMutation } from '@apollo/client'
import cx from 'classnames'
import rollbar from 'helpers/rollbar'
import { resultHistoryFragment } from './ResultHistory'
import { useToast } from './Toast'
import {
  SendRegReminderEmailMutation,
  SendRegReminderEmailMutationVariables,
} from './__generated__/SendRegReminderEmailMutation'

const sendRegReminderEmailMutation = gql`
  mutation SendRegReminderEmailMutation($id: ID!) {
    sendRegReminderEmail(resultId: $id) {
      result {
        id
        lastReminderEmailAt
        lastReminderEmailBy
        ...ResultHistoryFragment
      }
    }
  }

  ${resultHistoryFragment}
`

interface SendRegReminderEmailButtonProps {
  resultId: string
  children: React.ReactNode
  className?: string
}

const SendRegReminderEmailButton = ({ resultId, children, className }: SendRegReminderEmailButtonProps) => {
  const { addToast } = useToast()

  const [sendRegReminderEmail, { loading }] = useMutation<
    SendRegReminderEmailMutation,
    SendRegReminderEmailMutationVariables
  >(sendRegReminderEmailMutation)

  const onSend = async () => {
    try {
      await sendRegReminderEmail({
        variables: { id: resultId },
      })

      addToast({
        messageType: 'success',
        title: 'Sent',
        content: `Reminder email sent`,
        timeout: 3000,
      })
    } catch (err) {
      rollbar.error('Error sending reg reminder email', err)
      addToast({
        messageType: 'error',
        title: 'Error',
        content: `Failed to send reg reminder email: ${err.message}`,
      })
    }
  }

  return (
    <button
      type="button"
      className={cx(className, 'button is-small is-outlined is-fullwidth', {
        'is-loading': loading,
      })}
      onClick={onSend}
    >
      {children}
    </button>
  )
}

export default SendRegReminderEmailButton
